<template>
    <collapse-transition mode="out-in" :duration="1000">
        <div v-if="show" class="col-12 ">
            <div class="lead pb-2 text-center" style="border-bottom: 1px solid;" v-html="titre"></div>
            <ul class="mt-1" style="list-style: none;">
                <li class="interligne" v-for="todo in list" v-bind:key="todo.id"><i class="fas fa-caret-right mr-2"></i> {{ todo }}</li>
            </ul>
        </div>
    </collapse-transition>
</template>
<script>
    import {CollapseTransition} from "vue2-transitions";

    export default {
        components: {
            CollapseTransition
        },
        name: "blocExperience",
        props: {
            titre: {
                type: String,
                default: "span",
                description: "Html tag to use for the badge."
            },
            list: {
                type: Array,
                default: function () {
                    return []
                },
                description: "Whether badge is of pill type",
            },
        },
        mounted: function () {
            this.show = true;
        },
        data() {
            return {
                show: false
            }
        }
    };
</script>
